export { TransactionsLocationsInformation } from './TransactionsLocationsInformation'
